import { render, staticRenderFns } from "./OdooClientInstance.vue?vue&type=template&id=0a4bfeea&scoped=true&"
import script from "./OdooClientInstance.vue?vue&type=script&lang=js&"
export * from "./OdooClientInstance.vue?vue&type=script&lang=js&"
import style0 from "./OdooClientInstance.vue?vue&type=style&index=0&id=0a4bfeea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bfeea",
  null
  
)

export default component.exports